import { QA_NAME_ARROW_BUTTON } from '../../../constants/qa'
import { getQaSelectorButtonValue } from '../../../utils/common'
import { getVerticalIconChevronDirection, IconChevron } from '../../Icon'

export function getChevronIconProps({ hasTooltip, isOpen, t }) {
  const iconAfterTooltip = isOpen
    ? t('Accordion.IconCloseTooltip')
    : t('Accordion.IconOpenTooltip')

  return {
    Icon: IconChevron,
    iconProps: { direction: getVerticalIconChevronDirection(isOpen) },
    qaContext: null,
    qaName: getQaSelectorButtonValue(QA_NAME_ARROW_BUTTON),
    tooltip: hasTooltip ? iconAfterTooltip : null,
  }
}

export function isDefaultStyle(variant) {
  return variant === 'style2' || variant === 'style3'
}
